import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/liquidation-funnel/:id',
    name: 'liquidation-funnel',
    component: () => import('@/components/Funnel/LiquidationFunnel/views/LiquidationFunnel.vue'),
    meta: {
        private: true,
        layout: Layout.HeaderOnly,
    },
    children: [
        {
            path: 'eligibility',
            name: 'liquidation-eligibility',
            component: () => import('@/components/Funnel/LiquidationFunnel/components/LiquidationEligibilityStep.vue'),
        },
        {
            path: 'payment',
            name: 'liquidation-payment',
            component: () => import('@/components/Funnel/LiquidationFunnel/components/LiquidationPaymentStep.vue'),
        },
        {
            path: 'stakeholders',
            name: 'liquidation-stakeholders',
            component: () => import('@/components/Funnel/LiquidationFunnel/components/LiquidationStakeholdersStep.vue'),
        },
        {
            path: 'organization',
            name: 'liquidation-organization',
            component: () => import('@/components/Funnel/LiquidationFunnel/components/LiquidationOrganizationStep.vue'),
        },
        {
            path: 'statements',
            name: 'liquidation-statements',
            component: () => import('@/components/Funnel/LiquidationFunnel/components/LiquidationStatementsStep.vue'),
        },
        {
            path: ':(.*)',
            redirect: { name: 'liquidation-funnel' },
        },
    ],
} as RouteRecordRaw;
